import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1.7 6.61l-4.57 6a1 1 0 01-1.58.01l-2.44-3.11a1.001 1.001 0 111.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 111.6 1.22v.03z",
			fillRule: "nonzero"
		})
	})
});
export { SvgCheckboxOn as ReactComponent };
